import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { fmtTime } from '../lib/format';

interface Availability {
  workingHours: Array<{ start: string; end: string }>;
  busy: Array<{ start: string; end: string }>;
}

/** Horario y franjas ocupadas del conductor en una fecha (sin datos de otros clientes). */
export function DayAvailability({ localDateTime }: { localDateTime: string }) {
  const date = localDateTime.slice(0, 10);
  const q = useQuery({ queryKey: ['availability', date], queryFn: () => api<Availability>('/bookings/availability', { query: { date } }), enabled: /^\d{4}-\d{2}-\d{2}$/.test(date) });
  if (!q.data) return null;
  const { workingHours, busy } = q.data;
  const chosen = new Date(`${localDateTime}:00-04:00`).getTime();
  const clash = busy.some((b) => chosen >= new Date(b.start).getTime() - 15 * 60_000 && chosen <= new Date(b.end).getTime() + 15 * 60_000);
  const outside = workingHours.length > 0 && !workingHours.some((w) => chosen >= new Date(w.start).getTime() && chosen < new Date(w.end).getTime());
  return (
    <div className="rounded-2xl bg-[var(--surface-2)] px-4 py-3 text-sm">
      <p>
        <span className="text-[var(--text-muted)]">Horario del conductor: </span>
        {workingHours.length ? workingHours.map((w) => `${fmtTime(w.start)}–${fmtTime(w.end)}`).join(', ') : 'consultar'}
      </p>
      {busy.length > 0 && <p><span className="text-[var(--text-muted)]">Ocupado: </span>{busy.map((b) => `${fmtTime(b.start)}–${fmtTime(b.end)}`).join(', ')}</p>}
      {clash && <p className="mt-1 font-medium text-amber-700 dark:text-amber-400">Esa hora coincide con otro servicio; el conductor podría proponerte otro horario.</p>}
      {!clash && outside && <p className="mt-1 font-medium text-amber-700 dark:text-amber-400">Fuera del horario habitual; el conductor decidirá si puede atenderte.</p>}
    </div>
  );
}
